if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.isInitialized = false;
        this.abortController = null;
        this.requestId = 0;
      }

      connectedCallback() {
        if (this.isInitialized) return;
        this.isInitialized = true;
        this.loadRecommendations();
      }

      disconnectedCallback() {
        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
      }

      loadRecommendations() {
        let url = this.dataset.url;
        if (!url || typeof url !== 'string' || !url.trim()) return;

        url = url.trim();
        if (url.startsWith('?')) {
          const rootUrl =
            window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/';
          url = `${rootUrl.replace(/\/$/, '')}/recommendations/products${url}`;
        }

        this.fetchAndRender(url);
      }

      fetchAndRender(url) {
        if (this.abortController) {
          this.abortController.abort();
        }
        this.abortController = new AbortController();
        const currentRequestId = ++this.requestId;

        fetch(url, { signal: this.abortController.signal })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP ${response.status} ${response.statusText}`);
            }
            return response.text();
          })
          .then((html) => {
            if (currentRequestId !== this.requestId || !this.isConnected) return;

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const recommendations = doc.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            if (e.name === 'AbortError') return;
            console.error('[ProductRecommendations] Error fetching recommendations:', e);
          });
      }
    }
  );
}

